import clsx from 'clsx';
import Heading from 'components/atoms/Heading/Heading';
import Card, { Props as CardProps } from './Card';
import classes from './CardWithTitle.module.scss';
import A from 'components/atoms/A/A';
import ChevronIcon from 'components/assets/ChevronIcon';

export type Props = { title: string; backButtonHref?: string } & CardProps;

export default function CardWithTitle({
  title,
  children,
  className,
  backButtonHref,
  onClick,
  ...rest
}: Props) {
  return (
    <Card
      className={clsx(classes.cardOverrides, className, onClick && classes.isClickable)}
      {...rest}
    >
      <div className={clsx(classes.topBar, backButtonHref && classes.topBarWithBackButton)}>
        {backButtonHref && (
          <A href={backButtonHref} className={classes.backButton} data-label="back">
            <ChevronIcon className={classes.backButtonArrow} />
          </A>
        )}
        <Heading level={5} className={classes.heading}>
          {title}
        </Heading>
      </div>
      <div className={classes.content}>{children}</div>
    </Card>
  );
}
